export const getDateOnly = (date) => {
  return new Date(date.toDateString());
};
